import { faHeadset } from "@fortawesome/free-solid-svg-icons";
import { useAppContext } from "../../State/Global/AppContext";
import OptInList from "./Optin/OptinList";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { PageHeader, Dropdown, Menu, Switch, Modal } from "antd";
import { isNativeIos, isNativeMobile, useIsMobileView } from "frontend-lib/Utils/Mobile";
import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import {
    ImportOutlined,
    InfoCircleOutlined,
    UserAddOutlined,
    PlusCircleOutlined,
    SendOutlined,
    NotificationOutlined,
} from "@ant-design/icons";
import { useFCMNotifications } from "./useFCMNotifications";
import pkg from "../../../package.json";
import ChatCounters from "Components/ChatCounters/ChatCounters";
import { Agent } from "frontend-lib/DomainTypes/User";
import NewCustomerForm from "Components/NewCustomerForm/NewCustomerForm";
import {
    ActionSheetButton,
    IonActionSheet,
    IonButton,
    IonIcon,
    IonLabel,
    IonLoading,
    IonSpinner,
} from "@ionic/react";
import { ellipsisHorizontal } from "ionicons/icons";
import { headerBackgroundColor } from "Styles/MobileColors";
import { Capacitor } from "@capacitor/core";
import { App } from "@capacitor/app";
import AgentDisplayName from "./AgentDisplayName";
import { useAtom } from "jotai";
import { optInVisibleWithCustomerAtom } from "State/Atoms";

interface ChatListHeadersProps {
    headerRef: any;
    disablePushNotifications: boolean;
    channels: {
        facebook: {
            isEnable: boolean;
        };
        webChat: {
            isEnable: boolean;
        };
        whatsapp: {
            isEnable: boolean;
        };
    };
    usersList: Array<Agent> | null;
    logoutCb: () => void;
}

export function ChatListHeaders({
    headerRef,
    disablePushNotifications,
    channels,
    usersList,
    logoutCb,
}: ChatListHeadersProps) {
    //@ts-ignore
    const { appState } = useAppContext();
    const [INM] = useIsMobileView();
    const { t } = useTranslation();
    const [showFCMNotifications, handleFCMNotificationClick] = useFCMNotifications();
    const [versionModal, setVersionModal] = useState(false);
    const [countersModal, setCountersModal] = useState(false);
    const [showSidebar, setShowSidebar] = useState(false);
    const [optInModal, setOptInModal] = useState(false);
    const [isActionSheetVisible, setIsActionSheetVisible] = useState(false);
    const [headerLoadingSpinnerIsLoading, setHeaderLoadingSpinnerIsLoading] = useState(false);

    const hideOptiweLogo = useMemo(() => {
        return Boolean(appState.workspaceConfig?.agent?.hideOptiweLogo);
    }, [appState.workspaceConfig?.agent?.hideOptiweLogo]);

    const [optInVisibleAtom, setOptInVisibleAtom] = useAtom(optInVisibleWithCustomerAtom);
    const handleNotificationsEnableClick = () => {
        handleFCMNotificationClick(!showFCMNotifications);
    };

    const [appVersion, setAppVersion] = useState<string>();
    useEffect(() => {
        if (isNativeMobile()) {
            App.getInfo().then((info) => setAppVersion(info.version));
        }
    }, []);

    function getAgentShowableIdentifier() {
        if (INM) {
            return (
                <IonLabel
                    style={{ display: "flex", alignItems: "center", flexDirection: "column" }}
                >
                    <h1
                        style={{
                            display: "flex",
                            alignItems: "center",
                        }}
                    >
                        {/* This spinner is here to center the workspace name */}
                        <IonSpinner style={{ visibility: "hidden" }} />
                        <b>{appState.workspaceName}</b>
                        <IonSpinner
                            name="circular"
                            style={{
                                visibility: headerLoadingSpinnerIsLoading ? undefined : "hidden",
                            }}
                        />
                    </h1>
                    <AgentDisplayName isLoadingCb={setHeaderLoadingSpinnerIsLoading} />
                </IonLabel>
            );
        }
        return (
            <>
                <b>{appState.workspaceName}</b>
                <IonSpinner
                    name="circular"
                    style={{
                        visibility: headerLoadingSpinnerIsLoading ? undefined : "hidden",
                        height: "1rem",
                    }}
                />
                <br />
                <AgentDisplayName isLoadingCb={setHeaderLoadingSpinnerIsLoading} />
            </>
        );
    }

    function getHeaderAvatar() {
        if (hideOptiweLogo) {
            return {
                icon: (
                    <div style={{ background: "#fff" }}>
                        <FontAwesomeIcon
                            style={{ color: "#000", fontSize: "1.6rem" }}
                            /**
                             //@ts-ignore */
                            icon={faHeadset}
                        />
                    </div>
                ),
            };
        }
        return { src: "https://app.optiwe.com/favicon.ico" };
    }
    const renderHeaderMobile = () => {
        const headerAvatar = getHeaderAvatar();

        const buttonEnableNotification = {
            text: t("notifications.enable"),
            data: {
                actionCb: () => handleFCMNotificationClick(true),
            },
        };
        const buttonDisableNotification = {
            text: t("notifications.disable"),
            role: "destructive",
            data: {
                actionCb: () => handleFCMNotificationClick(false),
            },
        };
        const buttons = [
            !showFCMNotifications ? buttonEnableNotification : buttonDisableNotification,
            channels.whatsapp.isEnable && {
                text: t("newChat"),
                data: {
                    actionCb: () => setShowSidebar(true),
                },
            },
            {
                text: "Whatsapp opt-in",
                data: {
                    actionCb: () => setOptInModal(true),
                },
            },
            {
                text: t("counters.menuItem"),
                data: {
                    actionCb: () => setCountersModal(true),
                },
            },
            {
                text: "Info",
                data: {
                    actionCb: () => setVersionModal(true),
                },
            },
            {
                text: t("Logout"),
                role: "destructive",
                data: {
                    actionCb: logoutCb,
                },
            },
        ];
        const actionSheetButtons = buttons.filter((b) => b) as Array<ActionSheetButton>;

        return (
            <>
                <div
                    style={{
                        padding: "1rem 0 .7rem 0",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        // ACA: poner bg color
                        backgroundColor: headerBackgroundColor,
                        //backgroundColor: "black",
                    }}
                >
                    <div>
                        <img src={headerAvatar.src} alt="Optiwe logo" />
                    </div>
                    <div>{getAgentShowableIdentifier()}</div>

                    <IonButton onClick={() => setIsActionSheetVisible(true)}>
                        <IonIcon icon={ellipsisHorizontal} />
                    </IonButton>
                </div>
                <IonActionSheet
                    cssClass={isNativeIos() ? "optiwe-action-sheet" : ""}
                    isOpen={isActionSheetVisible}
                    onDidDismiss={({ detail }) => {
                        detail.data?.actionCb();
                        setIsActionSheetVisible(false);
                    }}
                    buttons={actionSheetButtons}
                />
            </>
        );
    };

    const renderHeaderWeb = () => {
        return (
            <div ref={headerRef}>
                <PageHeader
                    title=""
                    subTitle={getAgentShowableIdentifier()}
                    avatar={getHeaderAvatar()}
                    extra={[
                        <Dropdown.Button
                            key={"HeaderMenu"}
                            trigger={["click"]}
                            overlay={
                                <Menu>
                                    {!disablePushNotifications && (
                                        <Menu.Item
                                            key="toggleNotifications"
                                            onClick={handleNotificationsEnableClick}
                                            icon={<NotificationOutlined />}
                                        >
                                            <span>{t("notifications.switchTitle")}</span>{" "}
                                            <Switch checked={showFCMNotifications} size="small" />
                                        </Menu.Item>
                                    )}
                                    {channels.whatsapp.isEnable && (
                                        <>
                                            <Menu.Item
                                                key="outbound"
                                                onClick={() => setShowSidebar(true)}
                                                icon={<SendOutlined />}
                                            >
                                                {t("newChat")}
                                            </Menu.Item>
                                            <Menu.Item
                                                key="optin"
                                                onClick={() => setOptInModal(true)}
                                                icon={<UserAddOutlined />}
                                            >
                                                Whatsapp Opt-in
                                            </Menu.Item>
                                        </>
                                    )}
                                    <Menu.Item
                                        key="counter"
                                        onClick={() => setCountersModal(true)}
                                        icon={<PlusCircleOutlined />}
                                    >
                                        {t("counters.menuItem")}
                                    </Menu.Item>
                                    <Menu.Item
                                        key="info"
                                        onClick={() => setVersionModal(true)}
                                        icon={<InfoCircleOutlined />}
                                    >
                                        Info
                                    </Menu.Item>
                                    <Menu.Item
                                        key="logout"
                                        onClick={logoutCb}
                                        icon={<ImportOutlined />}
                                    >
                                        {t("Logout")}
                                    </Menu.Item>
                                </Menu>
                            }
                        />,
                    ]}
                />
            </div>
        );
    };

    const renderAppVersion = (): string | null => {
        if (appVersion) {
            const platformCapitalized = Capacitor.getPlatform()
                .split("")
                .map((v, i) => (i === 0 ? v.toUpperCase() : v))
                .join("");
            return `${platformCapitalized} version ${appVersion}`;
        }
        return null;
    };

    return (
        <>
            {INM ? renderHeaderMobile() : renderHeaderWeb()}
            <OptInList
                visible={showSidebar || optInVisibleAtom.visible}
                customer={optInVisibleAtom.customer}
                closeCb={() => {
                    setShowSidebar(false);
                    setOptInVisibleAtom({ visible: false });
                }}
            />
            <NewCustomerForm
                visible={optInModal}
                optIntModalCb={(isOpen: boolean) => setOptInModal(isOpen)}
            />
            <ChatCounters
                visible={countersModal}
                countersModalCb={(isOpen: boolean) => setCountersModal(isOpen)}
                usersList={usersList}
                usersPaginatorHasNext={false} // since userlist is fully loaded in chatlist
                nextUsersPageCb={() => {}} // since userlist is fully loaded in chatlist
            />
            <Modal
                title={"Version"}
                open={versionModal}
                onOk={() => setVersionModal(false)}
                onCancel={() => setVersionModal(false)}
            >
                Optiwe version {pkg.version}
                <br />
                {renderAppVersion()}
            </Modal>
        </>
    );
}
